import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import enTransactions from '../locales/en/transactions.json';
import enReports from '../locales/en/reports.json';
import enAdmin from '../locales/en/admin.json';
import enCategories from '../locales/en/categories.json';

import ruCommon from '../locales/ru/common.json';
import ruTransactions from '../locales/ru/transactions.json';
import ruReports from '../locales/ru/reports.json';
import ruAdmin from '../locales/ru/admin.json';
import ruCategories from '../locales/ru/categories.json';

import esCommon from '../locales/es/common.json';
import esTransactions from '../locales/es/transactions.json';
import esReports from '../locales/es/reports.json';
import esAdmin from '../locales/es/admin.json';
import esCategories from '../locales/es/categories.json';

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
] as const;

export type LanguageCode = typeof languages[number]['code'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        transactions: enTransactions,
        reports: enReports,
        admin: enAdmin,
        categories: enCategories,
      },
      ru: {
        common: ruCommon,
        transactions: ruTransactions,
        reports: ruReports,
        admin: ruAdmin,
        categories: ruCategories,
      },
      es: {
        common: esCommon,
        transactions: esTransactions,
        reports: esReports,
        admin: esAdmin,
        categories: esCategories,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'transactions', 'reports', 'admin', 'categories'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  });

export default i18n;
